export default {"src":"/_next/static/media/flower.689c7d9e.gif","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};